<template>
  <div id="highlight">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-star"></i> Postingan Sorotan
      <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'highlightHelper' }"></i>
      <div id="auto-highlight" class="form-check switch switch-lg success pull-right m-b-0">
        <label for="switchSample" id="toggle-highlight"><b>Sorotan Otomatis</b></label>
        <i class="bi bi-question-circle text-blue m-r-20" v-tooltip.right="{ ref: 'autoHighlightHelper' }"></i>
        <input type="checkbox" id="switchSample" v-model="auto_highlight" @change="autoHighlight"
          :disabled="disable_toggle" />
        <label for="switchSample">Izinkan</label>
      </div>
    </h6>
    <div ref="highlightHelper" class="tooltip-content">
      <p>
        <b>Postingan Sorotan</b> merupakan kumpulan postingan yang disorot. Sistem
        akan menyoroti postingan-postingan yang memiliki pokok bahasan yang
        serupa dengan postingan yang disorot.
      </p>
      <p>Anda dapat menambahkan postingan baru pada halaman Mentions.</p>
    </div>
    <div ref="autoHighlightHelper" class="tooltip-content">
      <p>
        <b>Postingan Sorotan Otomatis</b>. Hidupkan sorotan otomatis untuk mengaktifkan
        fitur otomatis menandai postingan yang serupa dengan postingan yang ada
        pada daftar Sorotan.
      </p>
    </div>

    <div class="table-wrapper m-b-20">
      <table class="table table-hover table-condensed" id="daftar-highlight" style="width: 100%">
        <thead>
          <tr>
            <th class="text-center" width="3%">No</th>
            <th>Postingan</th>
            <th v-if="isAdmin" width="10%" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading">
            <td colspan="3" align="center">Loading...</td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
export default {
  name: "tab_highlight_post",
  data() {
    return {
      tour_steps: [],
      is_loading: false,
      higlight_list: [],
      table: null,
      auto_highlight:
        this.$store.getters.user.project.project_detail["auto-highlight"],
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      disable_toggle: false,
      user_project: this.$store.getters.user.project,
    };
  },
  methods: {
    getData: function () {
      this.is_loading = true;
      let api =
        process.env.VUE_APP_API_URL + "highlight-base/" + this.id_project;
      this.higlight_list = [];
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.higlight_list = response.data;
          }
          this.generateTable("#daftar-highlight", this.higlight_list);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    generateTable: function (id, data) {
      let c = 0;
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            // emptyTable: "Mohon maaf, data tidak tersedia!",
            search: "Cari:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
            "paginate": {
              "next": "Lanjut",
              "previous": "Sebelum"
            }
          },
          columns: [{ data: "no" }, { data: "full_text" }, { data: "action" }],
          columnDefs: [
            {
              render: function () {
                c++;
                let index = `<center>${c}</center>`;
                return index;
              },
              orderable: false,
              targets: 0,
            },
            {
              render: function (data, type, row) {
                let btn =
                  '<center><button id="hapus-highlight" class="btn btn-danger btn-sm del" data-id="' +
                  row._id.$oid +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 2,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            // emptyTable: "Mohon maaf, data tidak tersedia!",
            search: "Cari:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
            "paginate": {
              "next": "Lanjut",
              "previous": "Sebelum"
            }
          },
          columns: [{ data: "no" }, { data: "full_text" }],
          columnDefs: [
            {
              render: function () {
                c++;
                let index = `<center>${c}</center>`;
                return index;
              },
              orderable: false,
              targets: 0,
            },
          ],
        });
      }
    },
    deleteHighlight: function (id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus posting tersebut dari daftar highlight.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "highlight-remove";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.getData();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus posting.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    autoHighlight: function () {
      this.$.pgNotification = notif;
      this.disable_toggle = true;
      let val = this.auto_highlight ? 1 : 0;
      let param = {
        _id: this.id_project,
        value: val,
      };
      let api = process.env.VUE_APP_API_URL + "auto-highlight-toggle";
      this.$http
        .post(api, param)
        .then((response) => {
          if (response.status == 200) {
            let project = this.user_project;
            project.project_detail["auto-highlight"] = param.value;
            this.$store.dispatch("user_project", project);
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Status auto highlight berhasil diubah!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          } else {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          }
        })
        .catch(() => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus data.',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.disable_toggle = false;
        });
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }
      return false;
    },
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    let self = this;
    self.$("#daftar-highlight tbody").on("click", ".del", function () {
      var tr = self.$(this).closest("tr");
      var data = self.table.row(tr).data();
      self.deleteHighlight(data.stream_id.$oid);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tab-vertical",
      header: {
        title: "Tab Menu",
      },
      content: `Anda dapat memilih salah satu untuk melihat detail dari menu.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#auto-highlight",
      header: {
        title: "Tombol Auto Highlight",
      },
      content: `Toggle auto highlight digunakan untuk mengaktifkan atau menonaktifkan status auto highlight.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#daftar-highlight_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari postingan yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#daftar-highlight",
      header: {
        title: "Tabel Highlight Postingan",
      },
      content: `Menampilkan daftar postingan yang dihighlight.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#hapus-highlight",
      header: {
        title: "Tombol Hapus Highlight",
      },
      content: `Klik untuk menghapus highlight postingan yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
#toggle-highlight:before {
  content: none !important;
}
</style>